<template>
  <div id="lm-wait">
    <LmSelect
      v-model="optionSelected"
      :options="options"
    />
  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'
export default {
  data () {
    return {
      optionSelected: ''
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        disabledOption: 'Seleccione un lapso de tiempo',
        content: []
      })
    }
  },
  components: {
    LmSelect
  }

}
</script>
